module.exports = __webpack_public_path__ + "img/vehicle-options-white-mazda.8a68c081.png";